import { send_request } from './Request';

export const loadDraftProject = (projectId) =>
  send_request(`project-service/project/${projectId}/canvas`, '', {}, 'GET').then(res => {
    // --- DIAG: check for null viewData in loaded draft ---
    const comps = res?.data?.components;
    if (Array.isArray(comps)) {
      const bad = comps.filter(c => !c.viewData);
      if (bad.length > 0) {
        console.error('[loadDraftProject] Server returned components with NULL viewData!', {
          projectId,
          badCount: bad.length,
          totalCount: comps.length,
          badIds: bad.map(c => ({ id: c.componentId, type: c.type })),
        });
      } else {
        console.log('[loadDraftProject] OK — all', comps.length, 'components have viewData', { projectId });
      }
    }
    return res;
  });

export const loadPublishedProject = (projectId) =>
  send_request(`project-service/project/${projectId}/canvas/published`, '', {}, 'GET');

export const loadProjectByVersion = (projectId, version) =>
  send_request(`project-service/project/${projectId}/canvas/version/${version}`, '', {}, 'GET');

export const saveCanvasEvent = (projectId, event) =>
  send_request(`project-service/project/${projectId}/canvas/save`, event, {}, 'POST').then(res => {
    if (res?.status >= 400 || res?.data?.updated === false) {
      console.error('[saveCanvasEvent] SAVE FAILED or not updated', {
        projectId,
        eventType: event?.type,
        status: res?.status,
        data: res?.data,
      });
    }
    return res;
  }).catch(err => {
    console.error('[saveCanvasEvent] SAVE ERROR', {
      projectId,
      eventType: event?.type,
      error: err?.message || err,
    });
    throw err;
  });

export const loadNextComponents = (projectId, componentId) =>
  send_request(`project-service/project/${projectId}/canvas/next-components/${componentId}`, '', {}, 'GET');
